__turbopack_context__.v({
  "blurb": "FeaturedProjects-module__3f1LEq__blurb",
  "content": "FeaturedProjects-module__3f1LEq__content",
  "item": "FeaturedProjects-module__3f1LEq__item",
  "list": "FeaturedProjects-module__3f1LEq__list",
  "name": "FeaturedProjects-module__3f1LEq__name",
  "stack": "FeaturedProjects-module__3f1LEq__stack",
  "year": "FeaturedProjects-module__3f1LEq__year",
});
